import { SegmentSkin } from "../tail/SegmentSkin";
import type { Charge, ChargeFireContext } from "./Charge";
import { lightningZigZagPattern } from "../weapons/patterns/LightningZigZagPattern";

/**
 * Lightning (zig-zag) laser charge.
 *
 * Currently uses a placeholder pattern that behaves like a single beam.
 * Keeping this separate lets us evolve the behavior later without touching
 * tail storage or food definitions.
 */
export class LightningCharge implements Charge {
  readonly id = "laser.lightning";
  readonly label = "Lightning";
  readonly skin = SegmentSkin.Icy;

  fire(ctx: ChargeFireContext): void {
    lightningZigZagPattern.fire(ctx);
  }
}
